var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"powered-by-footer"},[_c('a',{staticClass:"powered-by-badge",attrs:{"href":"https://teamio.app","target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"bolt"},[_vm._v("⚡")]),_vm._v("\n    Powered by "),_c('strong',[_vm._v("Teamio.app")])])])
}]

export { render, staticRenderFns }